/** Tema flat da área pública (sem degradês). */
export const publicColors = {
    primary: '#2563EB',
    primaryDark: '#1D4ED8',
    primarySoft: '#EFF6FF',
    ink: '#0F172A',
    inkMuted: '#475569',
    inkSoft: '#64748B',
    surface: '#FFFFFF',
    surfaceAlt: '#F8FAFC',
    border: '#E2E8F0',
    accent: '#0D9488',
    accentSoft: '#CCFBF1',
    warning: '#D97706',
    danger: '#DC2626',
};

export const publicFontFamily = '"Plus Jakarta Sans", "Segoe UI", system-ui, sans-serif';

export const publicDisplayFont = '"Space Grotesk", "Plus Jakarta Sans", "Segoe UI", system-ui, sans-serif';

export const publicEditorialBannerSx = {
    width: '100%',
    minHeight: { xs: 140, sm: 156 },
    px: { xs: 2.5, md: 3.25 },
    py: { xs: 2, md: 2.25 },
    borderRadius: 2,
    bgcolor: publicColors.primarySoft,
    color: publicColors.ink,
    border: `1px solid ${publicColors.primary}33`,
    borderLeft: `4px solid ${publicColors.primary}`,
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
};

export const publicEditorialTitleSx = {
    fontFamily: publicDisplayFont,
    fontWeight: 700,
    fontSize: { xs: '1.2rem', sm: '1.45rem', md: '1.7rem' },
    letterSpacing: '-0.04em',
    lineHeight: 1.12,
    mb: 0.75,
    color: publicColors.ink,
    textTransform: 'uppercase',
    width: '100%',
};

export const publicEditorialBodySx = {
    fontFamily: publicFontFamily,
    fontWeight: 500,
    fontSize: { xs: '0.92rem', sm: '1rem' },
    letterSpacing: '-0.01em',
    lineHeight: 1.55,
    color: publicColors.inkMuted,
    width: '100%',
};

export const publicHeroFontSx = {
    fontFamily: publicFontFamily,
    letterSpacing: '-0.045em',
    lineHeight: 1.02,
};

export const publicSectionSx = {
    py: { xs: 6, md: 9 },
    px: 2,
};

export const publicContainerSx = {
    maxWidth: 1120,
    mx: 'auto',
};

export const publicH2Sx = {
    fontWeight: 700,
    fontSize: { xs: '1.75rem', md: '2.25rem' },
    color: publicColors.ink,
    letterSpacing: '-0.02em',
    mb: 1,
    fontFamily: publicFontFamily,
};

export const publicSubtitleSx = {
    color: publicColors.inkMuted,
    fontSize: { xs: '1rem', md: '1.125rem' },
    lineHeight: 1.65,
    maxWidth: 720,
    mx: 'auto',
    fontFamily: publicFontFamily,
};

export const publicCardSx = {
    bgcolor: publicColors.surface,
    border: `1px solid ${publicColors.border}`,
    borderRadius: 2,
    p: 3,
    height: '100%',
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
    '&:hover': {
        borderColor: publicColors.primary,
        boxShadow: '0 4px 24px rgba(15, 23, 42, 0.06)',
    },
};
